'use client';

import { OraclePriceData } from '@velocity-exchange/sdk';
import { MarketId } from '@velocity-exchange/common';
import { useCallback } from 'react';
import { getLiveRawOracleData } from 'src/stores/marketLiveState';

/**
 * Returns a function to get full OraclePriceData (SDK BN type) for any market,
 * read from the market live-state module (best across transports).
 */
const useGetRawOracleDataForMarket = () => {
	return useCallback(
		(marketId: MarketId): OraclePriceData | undefined =>
			getLiveRawOracleData(marketId),
		[]
	);
};

export default useGetRawOracleDataForMarket;
